export interface LoginResponse {
  accessToken: string;
  tokenType: string;
  isTempPassword: boolean;
}

export const loginResponseFromResponse = (
  responseData: any,
): LoginResponse => ({
  accessToken: responseData.access_token,
  tokenType: responseData.token_type,
  isTempPassword: responseData.is_temp_password,
});
